module.exports = __webpack_public_path__ + "static/bg-285a0a73d96899188f9e7e024d5e10e9.png";